import { useGsCloudBackend } from '@gat-ship/http-client'
import type {
  AddCompanyRequest,
  ChangeCompanyDetailsRequest,
  ChangeCompanyDetailsResponse,
  CompanyAddedResponse,
  DeactivateCompanyRequestResponse,
  GetCompaniesResponse,
  ReactivateCompanyRequestResponse
} from '@gat-ship/types'

export function useCompanyApiCalls() {
  const { apiGet, apiPost, apiPut } = useGsCloudBackend()
  async function fetchCompaniesRequest(options?: {
    includeInactive?: boolean
  }) {
    const query = options?.includeInactive ? `?include_inactive=true` : ``
    const response = await apiGet<GetCompaniesResponse>(
      `organization/companies${query}`
    )
    return response
  }

  async function addCompanyRequest(
    payload: AddCompanyRequest,
    commandId: string
  ) {
    const response = await apiPost<CompanyAddedResponse, AddCompanyRequest>(
      'organization/companies',
      payload,
      commandId
    )
    return response
  }

  /** Represent a command that can be used to update basic company details such as name and description. */
  async function changeCompanyDetailsRequest(
    companyCode: string,
    payload: ChangeCompanyDetailsRequest,
    commandId: string
  ) {
    const response = await apiPut<
      ChangeCompanyDetailsResponse,
      ChangeCompanyDetailsRequest
    >(
      `organization/companies/${companyCode}/change-details`,
      payload,
      commandId
    )
    return response
  }

  async function deactivateCompanyRequest(
    companyCode: string,
    commandId: string
  ) {
    const response = await apiPut<DeactivateCompanyRequestResponse, undefined>(
      `organization/companies/${companyCode}/deactivate`,
      undefined,
      commandId
    )
    return response
  }

  async function reactivateCompanyRequest(
    companyCode: string,
    commandId: string
  ) {
    const response = await apiPut<ReactivateCompanyRequestResponse, undefined>(
      `organization/companies/${companyCode}/reactivate`,
      undefined,
      commandId
    )
    return response
  }

  return {
    fetchCompaniesRequest,
    addCompanyRequest,
    changeCompanyDetailsRequest,
    deactivateCompanyRequest,
    reactivateCompanyRequest
  }
}
